import { useState, useEffect } from 'react';
import messageService from "../../utils/MessageService.js";
import './MessageContainer.css'

function MessageContainer() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // Подписываемся на обновления
    const unsubscribe = messageService.subscribe(setMessages);

    // Cleanup функция - отписываемся при размонтировании
    return unsubscribe;
  }, []);

  return (
    <div className='MessageContainer'>
      {messages.map((message, index) => (
        <div className='Message'
          style={{ background: message.background }}
          key={`mess-${index}`}
        >
          <strong style={{ color: '#fff' }}>{message.text}</strong>
        </div>
      ))}
    </div>
  );
}

export default MessageContainer;